import { render, staticRenderFns } from "./BigscootUI.vue?vue&type=template&id=2ea4a9c5&scoped=true"
import script from "./BigscootUI.vue?vue&type=script&lang=js"
export * from "./BigscootUI.vue?vue&type=script&lang=js"
import style0 from "./BigscootUI.vue?vue&type=style&index=0&id=2ea4a9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea4a9c5",
  null
  
)

export default component.exports